import type { ReactNode } from 'react'
import flattenChildren from 'react-keyed-flatten-children'

/**
 * Checks whether the given {@link node} is effectively an empty React node.
 *
 * @param node
 */
export function isEmptyNode(node: ReactNode) {
  return flattenChildren(node).length === 0
}
